import axios from 'axios'
import {
  GET_ALL_COMMANDE,
  GET_ALL_USER,
  GET_PROFILE,
  REMOVE_USER,
  UPDATE_ALL_USER,
  UPDATE_PROFILE,
  UPDATE_PROFILE_ERR,
} from '../constants'

export const userUpdate = (profile) => async (dispatch) => {
  try {
    const res = await axios({
      method: 'put',
      url: `${process.env.REACT_APP_SERVER}user/update`,
      data: profile,
      headers: {
        'access-token': localStorage.getItem('token'),
      },
    })
    dispatch({
      type: UPDATE_PROFILE,
      payload: res.data.user,
    })
    return res
    //localStorage.setItem('user', JSON.stringify(res.data.user))
  } catch (error) {
    dispatch({
      type: UPDATE_PROFILE_ERR,
      payload: error.status,
    })
    console.log(error)
  }
}

export const getUserToken = (token) => async (dispatch) => {
  try {
    const res = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_SERVER}user/get`,
      headers: {
        'access-token': localStorage.getItem('token'),
      },
    })
    dispatch({
      type: GET_PROFILE,
      payload: res.data.user,
    })
    localStorage.setItem('user', JSON.stringify(res.data.user))
  } catch (error) {
    dispatch({
      type: UPDATE_PROFILE_ERR,
      payload: error.status,
    })
    localStorage.clear()
    console.log(error.response)
  }
}

export const allUser = (token) => {
  return async (dispatch) => {
    return axios
      .get(`${process.env.REACT_APP_SERVER}user/all`, {
        headers: { token: token },
      })
      .then((res) => {
        dispatch({
          type: GET_ALL_USER,
          payload: res.data,
        })
      })
      .catch((err) => {
        console.log(err.response)
      })
  }
}

export const allCommande = (token) => {
  return async (dispatch) => {
    return axios
      .get(`${process.env.REACT_APP_SERVER}command/index`, {
        headers: { token: token },
      })
      .then((res) => {
        dispatch({
          type: GET_ALL_COMMANDE,
          payload: res.data,
        })
      })
      .catch((err) => {
        console.log(err.response)
      })
  }
}

export const allAdmin = (token) => {
  return async (dispatch) => {
    return axios
      .get(`${process.env.REACT_APP_SERVER}user/admin/all`, {
        headers: { 'x-access-token': token },
      })
      .then((res) => {
        dispatch({
          type: GET_ALL_USER,
          payload: res.data,
        })
      })
      .catch((err) => {
        console.log(err.response)
      })
  }
}

export const allCandidat = (token) => {
  return async (dispatch) => {
    return axios
      .get(`${process.env.REACT_APP_SERVER}user/apply/all`, {
        headers: { 'x-access-token': token },
      })
      .then((res) => {
        dispatch({
          type: GET_ALL_USER,
          payload: res.data,
        })
      })
      .catch((err) => {
        console.log(err.response)
      })
  }
}

export const myAdminUpdateUser = (token) => {
  return async (dispatch) => {
    return axios
      .get(`${process.env.REACT_APP_SERVER}commande/all`, {
        headers: { 'x-access-token': token },
      })
      .then((res) => {
        dispatch({
          type: GET_ALL_USER,
          payload: res.data,
        })
      })
      .catch((err) => {
        console.log(err.response)
      })
  }
}

export const removeUser = (id) => async (dispatch) => {
  try {
    await axios({
      method: 'put',
      url: `${process.env.REACT_APP_SERVER}user/${id}`,
      headers: {
        'access-token': localStorage.getItem('token'),
      },
    })
    dispatch({
      type: REMOVE_USER,
      payload: id,
    })
    return { message: 'removed' }
  } catch (error) {
    dispatch({
      type: UPDATE_PROFILE_ERR,
      payload: error.status,
    })
    console.log(error)
    return error
  }
}

export const createAdmin = (token, data) => {
  return async (dispatch) => {
    return axios
      .post(`${process.env.REACT_APP_SERVER}user/admin/create`, data, {
        headers: { 'x-access-token': token },
      })
      .then((res) => {
        dispatch({
          type: UPDATE_ALL_USER,
          payload: data,
        })
        return res
      })
      .catch((err) => {
        dispatch({
          type: 'CREATE_ERR',
          payload: err.response,
        })
        console.log(err.response)
        return err.response
      })
  }
}

export const getCandidacies = () => async (dispatch) => {
  return await axios({
    method: 'get',
    url: `${process.env.REACT_APP_SERVER}candidacy/all`,
    headers: {
      'access-token': localStorage.getItem('token'),
    },
  })
    .then((res) => {
      console.log(res)
      dispatch({
        type: GET_ALL_USER,
        payload: res.data,
      })
    })
    .catch((err) => {
      dispatch({
        type: UPDATE_PROFILE_ERR,
        payload: err.response.status,
      })
    })
}

export const createCandidacy = (data) => {
  return (dispatch) =>
    axios({
      method: 'post',
      url: `${process.env.REACT_APP_SERVER}candidacy/create`,
      data: data,
    })
      .then((res) => {
        dispatch({
          type: 'CANDIDACY',
          payload: res,
        })
        return res
      })
      .catch((err) => {
        dispatch({
          type: 'C_ERROR',
          payload: err.response.data,
        })
      })
}
